<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99935 4.16667C11.1499 4.16667 12.0827 3.23392 12.0827 2.08333C12.0827 0.932742 11.1499 0 9.99935 0C8.84877 0 7.91602 0.932742 7.91602 2.08333C7.91602 3.23392 8.84877 4.16667 9.99935 4.16667Z"
      fill="#153D49"
    />
    <path
      d="M9.99935 11.3337C11.1499 11.3337 12.0827 10.4009 12.0827 9.25033C12.0827 8.09974 11.1499 7.16699 9.99935 7.16699C8.84877 7.16699 7.91602 8.09974 7.91602 9.25033C7.91602 10.4009 8.84877 11.3337 9.99935 11.3337Z"
      fill="#153D49"
    />
    <path
      d="M9.99935 18.5007C11.1499 18.5007 12.0827 17.5679 12.0827 16.4173C12.0827 15.2667 11.1499 14.334 9.99935 14.334C8.84877 14.334 7.91602 15.2667 7.91602 16.4173C7.91602 17.5679 8.84877 18.5007 9.99935 18.5007Z"
      fill="#153D49"
    />
  </svg>
</template>
